module.exports = __webpack_public_path__ + "static/feature3-7108aba4cbda020c76739ecc4e95e476.png";